/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useEffect, useImperativeHandle, useRef } from "react";
import { cn } from "tailwind-variants";
import { filterDomProps } from "common/vue/filter-dom-props";
import { VueTeleport } from "common/vue/VueTeleport";
import { useVueProps, vueDefaultValue } from "common/vue/useVueProps";
/* eslint-disable max-lines-per-function */
import "./CommonModal.react.scss";
import MenuCloseIcon from "assets/icons/menu-close.svg";

// @ts-expect-error TS(6133): 'rawProps' is declared but its value is never read... Remove this comment to see the full error message
function getDefaultProps(rawProps: any) {
  return {
    title: vueDefaultValue(undefined),
    compact: vueDefaultValue(false),
    hideCloseButton: vueDefaultValue(false),
    bottomAligned: vueDefaultValue(false)
  };
}

export default function CommonModal({ ref, ...rawProps }: any) {
  const { className, title, compact, hideCloseButton, bottomAligned, ...restProps } = rawProps;

  const props = useVueProps(rawProps, getDefaultProps);
  const modalRef = useRef(null);

  function $$modal() {
    // @ts-expect-error TS(2581): Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
    return $(modalRef.current);
  }

  function onShow() {
    $$modal()
      .modal("show")
      .on("hidden.bs.modal", (e: any) => {
        $$modal().off("hidden.bs.modal");
        if (e.target.id === $$modal()[0].id) {
          props.current.onClose?.();
          close();
        }
      });
  }

  function close() {
    $$modal().modal("hide");
  }

  useImperativeHandle(ref, () => ({ close }));

  useEffect(() => {
    onShow();
  }, []);

  return (
    <VueTeleport
      {...restProps}
      className={cn("scope-669571c0", className)}
      to="body"
      data-testid="teleport"
    >
      <div
        className={cn("modal", "common-modal", "scope-669571c0")}
        id="common-modal"
        ref={modalRef}
        role="dialog"
        data-testid="modal"
      >
        <div
          className={cn(
            [
              "common-modal__modal-box modal-dialog scope-669571c0",
              {
                "common-modal__modal-box--no-padding": props.current.compact,
                "common-modal__modal-box--bottom-aligned": props.current.bottomAligned
              }
            ],
            className
          )}
          // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
          {...filterDomProps(restProps)}
        >
          {!props.current.hideCloseButton ? (
            <button
              className={cn("common-modal__modal-button-close scope-669571c0", {
                "common-modal__modal-button-close--no-bg": props.current.compact
              })}
              type="button"
              onClick={close}
              data-testid="common-modal-modal-button-close"
            >
              <MenuCloseIcon
                className={cn("common-modal__modal-button-close-icon", "scope-669571c0")}
                data-testid="common-modal-modal-button-close-icon"
              />
            </button>
          ) : null}
          {props.current.title ? (
            <div
              className={cn("common-modal__modal-header", "scope-669571c0")}
              role="heading"
              // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'number'.
              tabIndex="0"
              data-testid="common-modal-modal-header"
            >
              <span className={cn("common-modal__title", "scope-669571c0")}>
                {props.current.title}
              </span>
            </div>
          ) : null}
          {rawProps.children}
        </div>
      </div>
    </VueTeleport>
  );
}
